import { Configuration } from "./configuration.model";

export class AppConfig {
    constructor() {
        this.apiUrl = '';
        this.htmlVersion = '';
        this.defaultConfiguration = new Configuration();
    }

    apiUrl: string;
    htmlVersion: string;
    country?: string;
    defaultConfiguration: Configuration;
}
